export default __webpack_public_path__ + "static/media/deli1-light.a4cfcc28.svg";